import React from "react";

function StoreLocator() {
    return (
      <div>StoreLocator</div>
    );
  }
  export default StoreLocator;